import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/ChaletAwayUI-2025/ChaletAwayUI-2025/src/app/[country]/[resort]/[chalet]/ChaletClientPage.tsx");
